import { useState } from 'react'

import type { MenuOption } from '@/components/ui/MenuItem'
import MenuSingle from '@/components/ui/MenuSingle'
import SelectTrigger from '@/components/ui/SelectTrigger'
import type { ScreenerView } from '@/features/screener/lib/screenState'

const VIEW_OPTIONS: readonly MenuOption<ScreenerView>[] = [
  { value: 'table', label: 'Table' },
  { value: 'chart', label: 'Chart' },
  { value: 'heatmap', label: 'Heatmap' },
]

/**
 * Table, Chart or Heatmap (the mock's `sca-view` select): the same matching stocks drawn three
 * ways. At the right end of whichever bar the view draws, so it never moves between them.
 */
export default function ViewMenu({
  value,
  onChange,
}: {
  value: ScreenerView
  onChange: (view: ScreenerView) => void
}) {
  const [open, setOpen] = useState(false)
  const label = VIEW_OPTIONS.find((option) => option.value === value)?.label ?? 'Table'

  return (
    <MenuSingle
      options={VIEW_OPTIONS}
      value={value}
      onChange={onChange}
      open={open}
      onOpenChange={setOpen}
      label="View"
      searchable={false}
      align="end"
      className="w-36"
      trigger={(triggerProps) => (
        <SelectTrigger
          {...triggerProps}
          aria-label={`View, ${label}`}
          label={label}
          open={open}
          className="shrink-0"
        />
      )}
    />
  )
}
